export default "__VITE_ASSET__BIfKDb$K__"